import React, {useState} from 'react';
import {observer} from "mobx-react-lite";
import {Badge, Card, Col, Divider, Modal, Rate, Row, Tag} from "antd";
import dayjs from "dayjs";
import ReviewOne from "../reviewOne/reviewOne";
import {StarOutlined} from "@ant-design/icons";

const Rewiews2025 = observer((props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            {(props.dta.reviews_count>0)?(
                // <Button type="primary" color={"red"}  value="small"onClick={showModal} shape="circle">{props.dta.cancelCount}</Button>
                <>

                       {/*<Tag onClick={showModal} color="volcano">{props.dta.rating}</Tag>*/}
                        {/*<Rate allowHalf disabled defaultValue={props.dta.rating} />*/}
                        {/*{props.dta.rating}*/}

                    <Tag
                        color="green"
                        onClick={showModal}
                        style={{
                            width: '100%',
                            color: 'black',
                            textAlign: 'center',      // Центрирование текста
                            display: 'block',          // Обязательно для корректного выравнивания в 100% ширины
                            cursor: 'pointer'
                        }}
                    >
                        {props.dta.ratingtext}
                    </Tag>
                    <Tag
                        color="green"
                        onClick={showModal}
                        style={{
                            width: '100%',
                            color: 'black',
                            textAlign: 'center',      // Центрирование текста
                            display: 'block',          // Обязательно для корректного выравнивания в 100% ширины
                            cursor: 'pointer'
                        }}
                    >
                     <StarOutlined />   {props.dta.rating}
                    </Tag>
                        {/*<Tag onClick={showModal} color="volcano">{props.dta.ratingtext}</Tag>*/}

                    <Modal   width={1600} title="Отзывы" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                        <>
                        <ReviewOne dta={props.dta} />
                        {/*{Object.entries(props.dta.reviews)*/}
                        {/*    .map( ([key, value]) =>*/}
                        {/*        <>*/}
                        {/*            <Card type="inner" title={*/}
                        {/*                <>*/}
                        {/*                    {(value.orderDeliveryType=="REVIEW_ORDER_DELIVERY_CANCELED")?(<Tag color="red-inverse">{dayjs("2023-05-21T16:48:57.300810Z").format("DD.MM.YYYY")}</Tag>):(*/}
                        {/*                        <Tag color="green-inverse">{dayjs("2023-05-21T16:48:57.300810Z").format("DD.MM.YYYY")}</Tag>)}*/}
                        {/*                     : {value.product.offer_id} {value.product.title}*/}
                        {/*                </>}*/}
                        {/*                  extra={*/}
                        {/*                  <>*/}
                        {/*                    <Rate disabled defaultValue={value.rating} allowHalf/>*/}

                        {/*                  </>}>*/}



                        {/*                        /!*<Rate disabled defaultValue={value.rating} allowHalf/>*!/*/}
                        {/*                        /!*<p>{dayjs("2023-05-21T16:48:57.300810Z").format("DD.MM.YYYY")}</p>*!/*/}
                        {/*                <p style={{ fontSize: '17px' }}>Плюсы: {value.text.positive} </p>*/}
                        {/*                <p style={{ fontSize: '17px' }}>Минусы: {value.text.negative} </p>*/}
                        {/*                <p style={{ fontSize: '17px' }}>Отзыв: {value.text.comment} </p>*/}
                        {/*            </Card>*/}
                        {/*            /!*<Divider >{value.ship_date_str} - {value.posting_number} </Divider>*!/*/}
                        {/*            /!*<h3>Заказ: {value.posting_number}</h3>*!/*/}
                        {/*            /!*<Row  align="middle">*!/*/}
                        {/*            /!*    <Col span={3}>*!/*/}
                        {/*            /!*        <div className={"virov"}>*!/*/}
                        {/*            /!*            {value.ship_date_str}*!/*/}
                        {/*            /!*        </div>*!/*/}
                        {/*            /!*    </Col>*!/*/}
                        {/*            /!*    /!*<Col span={6}>*!/*!/*/}
                        {/*            /!*    /!*    <div className={"virov"}>*!/*!/*/}
                        {/*            /!*    /!*        {value.posting_number}*!/*!/*/}
                        {/*            /!*    /!*    </div>*!/*!/*/}
                        {/*            /!*    /!*</Col>*!/*!/*/}
                        {/*            /!*    <Col span={3}>*!/*/}
                        {/*            /!*        <div className={"virov"}>*!/*/}
                        {/*            /!*            {value.status_rus}*!/*/}
                        {/*            /!*        </div>*!/*/}
                        {/*            /!*    </Col>*!/*/}
                        {/*            /!*    /!*<Col span={6}>*!/*!/*/}
                        {/*            /!*    /!*    <div className={"virov"}>*!/*!/*/}
                        {/*            /!*    /!*        {value.substatus_rus}*!/*!/*/}
                        {/*            /!*    /!*    </div>*!/*!/*/}
                        {/*            /!*    /!*</Col>*!/*!/*/}


                        {/*            /!*    {(value.Cancel_reason!="")?*!/*/}

                        {/*            /!*        (*!/*/}
                        {/*            /!*            <>*!/*/}
                        {/*            /!*                /!*<a>AAA={value.Cancel_reason}</a>*!/*!/*/}
                        {/*            /!*                <Col span={7}>*!/*/}
                        {/*            /!*                    {value.prodlist.map((valuez) =>*!/*/}
                        {/*            /!*                        <p>{valuez}</p>*!/*/}
                        {/*            /!*                    )} </Col>*!/*/}
                        {/*            /!*                <Col span={5}>*!/*/}
                        {/*            /!*                    <Tag color={"red"}>{value.Cancel_reason}</Tag>*!/*/}
                        {/*            /!*                </Col>*!/*/}
                        {/*            /!*            </>*!/*/}
                        {/*            /!*        ):(<>*!/*/}
                        {/*            /!*            /!*<a>BBB={value.Cancel_reason}</a>*!/*!/*/}
                        {/*            /!*            <Col span={15}>*!/*/}
                        {/*            /!*                {value.prodlist.map((valuez) =>*!/*/}
                        {/*            /!*                    <p>{valuez}</p>*!/*/}
                        {/*            /!*                )} </Col>*!/*/}
                        {/*            /!*        </>)}*!/*/}

                        {/*            /!*</Row>*!/*/}


                        {/*        </>*/}

                        {/*    )}*/}
                        </>
                    </Modal>

                </>
            ):(
                <></>
            )}



        </>
    );
})

export default Rewiews2025;